import React from 'react';
import '../App.css';
import TimeAgo from 'react-timeago';
import Post from './Post';

export default class Message extends React.Component {

  constructor(props) {
    super(props);
    if (props && props.data) {
      this.state = {message: this.props.data};
    }
  }

  showProfile(event, user) {
    event.preventDefault();
    // Set post to empty or the App will show the last post shown in teh timeline
    // if one has been shown.  Unclean but we can clean this up later. It's front end
    // stuff after all :)
    this.props.app.setState({profile: user, post: ''});
  }
  
  render() {
    let imageUrl = undefined;
    if ( this.props.data.image_url && this.props.data.image_url.indexOf('missing.png') === -1) {
      imageUrl = window.location.protocol + this.props.data.image_url;
    }
    let className = 'message';
    if (this.props && this.props.current_user && this.props.current_user.username  === this.state.message.user.username) {
      className = 'messageOurs';
    }
    let body = this.state.message.body;
    if (this.props.data.is_command || this.state.message.is_command) {
      if (typeof body === 'object') {
        body = <i>{body.text}</i>;
        if (body.title) {
          this.props.app._messageViewer.props.convo.setState({latestMessage: body.text});
        }
      } else {
        body = <i>{body}</i>;
      }
    }
    let messageBody = '';
    if (this.props.data.post) {
      messageBody = <Post key={this.props.data.post._id['$oid']} app={this.props.app} current_user={this.props.current_user} data={this.props.data.post} userConvoUser={this.props.userConvoUser} />;
    } else {
      let name = this.state.message.user.username;
      if (this.state.message.conversation_user && this.state.message.conversation_user.conversation_role) {
        name += ' (' + this.state.message.conversation_user.conversation_role.name + ')';
        if (this.state.message.conversation_user.conversation_role.name.indexOf('Admin') !== -1) {
          body = <font className='adminMessage'>{body}</font>;
        }
      }
      /* let adminFlag = '', unAdminFlag = '';
      if (this.props.userConvoUser.conversation_role && this.props.userConvoUser.conversation_role.name.indexOf('Admin') !== -1) {
        if (this.state.message.user.username !== this.props.current_user.username) {
          if (this.state.message.message_conversation_user && ( ( this.state.message.message_conversation_user.conversation_role && this.state.message.message_conversation_user.conversation_role.name.indexOf('Admin') === -1 ) || !this.state.message.message_conversation_user.conversation_role)) {
            adminFlag = <button onClick={(e) => this.makeAdmin(e)}>Make Admin</button>;
          } else if (this.state.message.message_conversation_user.conversation_role && this.state.message.message_conversation_user.conversation_role.name === 'Admin') { 
            unAdminFlag = <button onClick={(e) => this.makeUnadmin(e)}>Remove Admin</button>;
          }
        }
      } */
          // {adminFlag || unAdminFlag}
      messageBody = <div className={className}>
          {imageUrl || ''}
          <img title={name} className='avatar' src={this.state.message.user.avatar} alt=''/> 
          <div className='messageBody'>{body}</div>
          <br />
          &nbsp;&nbsp;<TimeAgo className='smallGreyFont' date={this.state.message['created_at']} />
        </div>;
    }
    return (<div style={{display: 'inline-block'}}>{messageBody}</div>);
  }
}

